import _extends from "@babel/runtime-corejs3/helpers/extends";
import { createVNode as _$cv, className as _$cn, noop as _$no, createUnknownComponentVNode as _$cc, createElementVNode as _$ce, map as _$ma } from 'intact-vue-next';
import { Button } from '../button';
import { Progress } from '../progress';
import { Dialog } from '../dialog';
import { expandAnimationCallbacks, getRestProps } from '../utils';
import { makeStyles, makeUploadDialogStyles } from './styles';
import { TransitionGroup, Transition, linkEvent } from 'intact-vue-next';
import { _$ } from '../../i18n';
import { Icon } from '../icon';
import { UploadFileStatus } from './useUpload';
export default function ($props, $blocks, $__proto__) {
  var _classNameObj, _$cn4;
  $blocks || ($blocks = {});
  $props || ($props = {});
  var $this = this;
  var _$blocks = {};
  var __$blocks = {};
  var _this$get = this.get(),
    className = _this$get.className,
    accept = _this$get.accept,
    multiple = _this$get.multiple,
    limit = _this$get.limit,
    files = _this$get.files,
    children = _this$get.children,
    type = _this$get.type,
    directory = _this$get.directory,
    disabled = _this$get.disabled;
  var drag = this.drag;
  var k = this.config.k;
  var classNameObj = (_classNameObj = {}, _classNameObj[k + "-upload"] = true, _classNameObj[className] = className, _classNameObj[k + "-drag"] = type === 'drag', _classNameObj[k + "-dragover"] = drag.dragOver.value, _classNameObj[k + "-gallery"] = type === 'gallery', _classNameObj[k + "-disabled"] = disabled, _classNameObj[makeStyles(k)] = true, _classNameObj);
  var events = {
    'ev-click': this.selectFile
  };
  if (type === 'drag') {
    events['ev-dragover'] = drag.stopEvent;
    events['ev-dragenter'] = drag.onDragEnter;
    events['ev-dragleave'] = drag.onDragLeave;
    events['ev-drop'] = drag.onDrop;
  }
  var handle = _$cv('div', _extends({
    'className': _$cn(k + "-upload-handle")
  }, events), (_$blocks['content'] = function ($super) {
    return children ? (_$blocks['children'] = function ($super) {
      return children;
    }, __$blocks['children'] = function ($super, data) {
      var block = $blocks['children'];
      var callBlock = function callBlock() {
        return _$blocks['children'].call($this, $super, data);
      };
      return block ? block.call($this, callBlock, data) : callBlock();
    }, __$blocks['children'](_$no)) : type !== 'gallery' ? type === 'select' ? _$cc(Button, {
      'disabled': disabled,
      'children': [_$cc(Icon, {
        'className': _$cn(k + "-icon-upload")
      }), _$('点击上传')]
    }) : _$ce(2, 'div', [_$cc(Icon, {
      'className': _$cn(k + "-icon-add-bold")
    }), _$ce(2, 'div', null, 1, null, {
      'innerHTML': _$('将文件拖到此处，或<a>点击上传</a>')
    })], 4, _$cn(k + "-upload-area")) : _$ce(2, 'div', [_$cc(Icon, {
      'className': _$cn(k + "-icon-add-bold"),
      'size': 'large'
    }), _$ce(2, 'div', _$('上传图片'), 0)], 4, _$cn(k + "-upload-picture-card " + k + "-upload-add"));
  }, __$blocks['content'] = function ($super, data) {
    var block = $blocks['content'];
    var callBlock = function callBlock() {
      return _$blocks['content'].call($this, $super, data);
    };
    return block ? block.call($this, callBlock, data) : callBlock();
  }, __$blocks['content'](_$no)));
  var removeFile = this.files.removeFile;
  var closeBtn = function closeBtn(value, index) {
    return _$cc(Icon, {
      'className': _$cn(k + "-upload-close " + k + "-icon-delete"),
      'ev-click': function evClick() {
        return removeFile(value, index);
      },
      'hoverable': true
    });
  };
  var _this$showImage = this.showImage,
    show = _this$showImage.show,
    close = _this$showImage.close,
    image = _this$showImage.image,
    isShow = _this$showImage.isShow;
  return _$cv('div', _extends({
    'className': _$cn(classNameObj)
  }, getRestProps(this)), [_$ce(64, 'input', null, 1, 'c-hidden', {
    'type': 'file',
    'accept': accept,
    'ev-change': this.onInputChange,
    'multiple': multiple,
    'directory': directory ? '' : undefined,
    'webkitdirectory': directory ? '' : undefined
  }, null, this.inputRef), type === 'gallery' ? _$ce(2, 'div', _$cc(TransitionGroup, {
    'name': 'k-dropdown',
    'children': [_$ma(files, function ($value, $key) {
      var _$cn2;
      return _$ce(2, 'div', [_$ce(2, 'img', null, 1, _$cn(k + "-upload-img"), {
        'src': $value.url
      }), _$cc(Transition, {
        'name': 'k-fade',
        'children': $value.status === UploadFileStatus.Ready || $value.status === UploadFileStatus.Uploading ? _$ce(2, 'div', _$cc(Progress, {
          'percent': $value.percent,
          'size': 'mini',
          'className': _$cn(k + "-upload-progress")
        }), 2, _$cn(k + "-upload-overlap"), null, 'overlap') : _$ce(2, 'div', [_$cc(Icon, {
          'className': _$cn(k + "-upload-zoom ion-ios-eye-outline"),
          'size': 'large',
          'hoverable': true,
          'ev-click': function evClick() {
            return show($value);
          }
        }), closeBtn($value, $key)], 0, _$cn(k + "-upload-overlap " + k + "-upload-icons"))
      })], 4, _$cn((_$cn2 = {}, _$cn2[k + "-upload-picture " + k + "-upload-picture-card"] = true, _$cn2[k + "-error"] = $value.status === UploadFileStatus.Error, _$cn2)), null, $value.uid);
    }, $this), !limit || files.length < limit ? _$ce(2, 'div', handle, 0, 'c-middle', null, 'handle') : undefined]
  }), 2, _$cn(k + "-upload-pictures")) : handle, $blocks.tip ? _$ce(2, 'div', (_$blocks['tip'] = function ($super) {
    return null;
  }, __$blocks['tip'] = function ($super, data) {
    var block = $blocks['tip'];
    var callBlock = function callBlock() {
      return _$blocks['tip'].call($this, $super, data);
    };
    return block ? block.call($this, callBlock, data) : callBlock();
  }, __$blocks['tip'](_$no)), 0, _$cn(k + "-upload-tip")) : undefined, type !== 'gallery' ? _$ce(2, 'div', _$cc(TransitionGroup, _extends({}, expandAnimationCallbacks, {
    'children': _$ma(files, function ($value, $key) {
      var _$cn3;
      return _$ce(2, 'div', [_$ce(2, 'div', [_$ce(2, 'div', [_$cc(Icon, {
        'className': _$cn(k + "-upload-file-icon ion-document")
      }), _$ce(2, 'span', $value.name, 0, _$cn(k + "-upload-file-name")), $value.status === UploadFileStatus.Done ? _$cc(Icon, {
        'className': _$cn(k + "-upload-status-icon " + k + "-icon-success-fill")
      }) : $value.status === UploadFileStatus.Error ? _$cc(Icon, {
        'className': _$cn(k + "-upload-status-icon " + k + "-icon-error-fill")
      }) : undefined], 0, _$cn(k + "-upload-name c-ellipsis")), _$cc(Transition, _extends({}, expandAnimationCallbacks, {
        'children': $value.status === UploadFileStatus.Ready || $value.status === UploadFileStatus.Uploading ? _$cc(Progress, {
          'percent': $value.percent,
          'size': 'mini',
          'className': _$cn(k + "-upload-progress")
        }) : undefined
      }))], 4, _$cn(k + "-upload-file-main")), closeBtn($value, $key)], 0, _$cn((_$cn3 = {}, _$cn3[k + "-upload-file"] = true, _$cn3[k + "-error"] = $value.status === UploadFileStatus.Error, _$cn3)), null, $value.uid);
    }, $this)
  })), 2, _$cn(k + "-upload-files")) : undefined, _$cc(Dialog, {
    'title': _$("查看图片"),
    'key': 'dialog',
    'value': isShow.value,
    'ev-close': close,
    'className': _$cn((_$cn4 = {}, _$cn4[k + "-upload-dialog"] = true, _$cn4[makeUploadDialogStyles(k)] = true, _$cn4)),
    'children': image.value ? _$ce(2, 'a', _$ce(2, 'img', null, 1, null, {
      'src': image.value.url
    }), 2, null, {
      'href': image.value.url,
      'target': '_blank'
    }) : undefined
  }, 'dialog')]);
}
;